import { Injectable } from '@angular/core';
import { ProductGroup } from '../models/products-group';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ProductsService } from './products.service';
import { LoggerService } from '../../../services/logger/logger.service';
import { ConnectionService } from '../../../services/connection/connection.service';
import { Category } from '../models/category';
import { ProductStockInformation } from '../models/product-stock-information';
import { ShopSettingsService } from '../../general/services/shop-settings.service';


@Injectable()
export class ProductsOdooService implements ProductsService {

  constructor(
    private logger: LoggerService,
    private connectionService: ConnectionService,
    private shopSettingsService: ShopSettingsService,
  ) {
  }

  get allProducts(): Observable<ProductGroup[]> {
    this.logger.info(`ProductsOdooService: allProducts requested.`);
    return this.connectionService.sendJsonPostRequest('/store/product/all-products', {
      profile: this.shopSettingsService.profile,
    }).pipe(
      map(
        productGroups => {
          this.logger.info(`ProductsOdooService: allProducts received.`);
          return productGroups ? productGroups.map(productGroup => ProductGroup.createFromAny(productGroup)) : [];
        }
      ),
      catchError(error => {
        return of(null);
      }),
    );
  }

  checkIsAvailableProductOnStock(stockProductRequestQuantity: ProductStockInformation[]): Observable<ProductStockInformation[]> {
    return of(false).pipe(
      switchMap(_ => {
        this.logger.info(`ProductsOdooService: checkIsAvailableProductOnStock requested.`);
        if (!stockProductRequestQuantity) {
          return of(stockProductRequestQuantity);
        }
        return this.connectionService.sendJsonPostRequest('/store/product/check-available-product', {
          stockProductRequestQuantity: stockProductRequestQuantity.map(item=>item.toJSON()),
        }).pipe(
          map(result => {
            this.logger.info(`ProductsOdooService: checkIsAvailableProductOnStock received.`);
            return result.map(item => ProductStockInformation.createFromAny(item));
          }),
        );
      })
    );
  }

  checkProductPin(productId: number, pin: string): Observable<boolean> {
    this.logger.info(`ProductsOdooService: checkProductPin requested.`);
    return this.connectionService.sendJsonPostRequest('/store/product/check-pin', { productId, pin }).pipe(
      map(
        result => {
          this.logger.info(`ProductsOdooService: checkProductPin received.`);
          return result;
        }
      ),
      catchError(error => {
        return of(false);
      }),
    );
  }


  findVariantProductByPin(pin: string, productTemplateId: number): Observable<number> {
    this.logger.info(`ProductsOdooService: findVariantProductByPin requested.`);
    return this.connectionService.sendJsonPostRequest('/store/product/find-variant-product-by-pin', { pin, productTemplateId }).pipe(
      map(
        result => {
          this.logger.info(`ProductsOdooService: findVariantProductByPin received.`);
          return result;
        }
      ),
      catchError(error => {
        return of(false);
      }),
    );
  }

  get categories(): Observable<Category[]> {
    this.logger.info(`ProductsOdooService: categories requested.`);
    return this.connectionService.sendJsonPostRequest('/store/product/categories').pipe(
      map(
        categories => {
          this.logger.info(`ProductsOdooService: categories received.`);
          return categories ? categories.map(category => Category.createFromAny(category)) : [];
        }
      ),
      catchError(error => {
        return of(null);
      }),
    );
  }
}
